<div class="footertext d-flex flex-column justify-content-center">
      <div>Cloudbite POS System | Powered by QubePos <span class="registered-symbol">&#174;</span></div>
      <div>&#169; {{currentYear}} Qube Apps Solutions Sdn. Bhd. All rights reserved.</div>
<!-- <b>Cloudbite POS System {{env.version}} | Powered by QubePos  <span class="registered-symbol">&#174;</span></b><br/>
      &#169; {{currentYear}} Qube Apps Sdn. Bhd. All rights reserved. -->
</div>